import React from 'react';
import { Table, Button, Tag } from 'antd';
import { constructColumn, constructColumnFilterSearch, constructColumnFilterRadio } from 'utils/table/table';
import { getConstantLabel, guard } from 'utils/general';

import { useFetchConstant } from 'hooks/constants';

const useFetchConstants = () => {
  const { selection: rateModifierTypes, isLoading: isRateModifierTypesLoading } = useFetchConstant('rateModifierType');
  const { selection: rateModifierSigns, isLoading: isRateModifierSignsLoading } = useFetchConstant('rateModifierSign');

  const selections = { rateModifierTypes, rateModifierSigns };
  const isLoading = isRateModifierTypesLoading || isRateModifierSignsLoading;

  return { selections, isLoading };
};

const constructColumns = (rateModifierTypes, rateModifierSigns, handleOnClickEditDiscount) => [
  {
    ...constructColumn('Discount Name', 'name', { hasSorter: true }),
    ...constructColumnFilterSearch('name', 'Search Discount Name'),
    render: (text, record) => {
      return (
        <Button type="link" onClick={() => handleOnClickEditDiscount(record)}>
          {text}
        </Button>
      );
    }
  },
  {
    ...constructColumn('Type', 'type', { hasSorter: true }),
    ...constructColumnFilterRadio('type', rateModifierTypes),
    render: type => getConstantLabel(rateModifierTypes, type)
  },
  {
    ...constructColumn('Amount/Percentage', 'amount', { hasSorter: true }),
    render: (text, record) => {
      const rateModifierTypeObject = rateModifierTypes.find(type => type.code === record.type);
      return guard(
        () =>
          rateModifierTypeObject.isPercentage ? (
            <Tag color="blue" style={{ fontSize: '14px', padding: '5px 10px' }}>{`${text}%`}</Tag>
          ) : (
            <Tag color="green" style={{ fontSize: '14px', padding: '5px 10px' }}>
              {text}
            </Tag>
          ),
        ''
      );
    }
  },
  {
    title: '# of Host',
    dataIndex: 'linkedHostIds',
    key: 'linkedHostIds',
    sorter: (a, b) => a.linkedHostIds - b.linkedHostIds
  },

  {
    ...constructColumn('Remark', 'remark')
  }
];

const TableComponent = ({ data, loading, onSelectedDiscount }) => {
  const {
    isLoading: isConstantsLoading,
    selections: { rateModifierTypes, rateModifierSigns }
  } = useFetchConstants();

  const handleOnClickEditDiscount = discount => {
    onSelectedDiscount(discount);
  };
  return (
    <>
      <Table columns={constructColumns(rateModifierTypes, rateModifierSigns, handleOnClickEditDiscount)} dataSource={data} loading={loading} />
    </>
  );
};

export default TableComponent;
